import request from "@/service";

/* 推送管理-统计分页列表 */
export function pushPage(data) {
  return request({
    url: "/user/sys/push/page",
    method: "get",
    params: data
  });
}

/* 推送管理发送状态分页列表 */
export function pushStatusPage(data) {
  return request({
    url: "/user/sys/push/statusPage",
    method: "get",
    params: data
  });
}
/* 删除推送记录 */
export function deletePush(data) {
  return request({
    url: "/user/sys/push/delete",
    method: "delete",
    data
  });
}
/* 重新发送推送 */
export function resendPush(data) {
  return request({
    url: "/user/sys/push/resend",
    method: "post",
    data
  });
}
